import React from 'react'
import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg' | 'xl'
    className?: string
    color?: 'primary' | 'secondary' | 'muted'
}

const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-24 w-24',
}

const colorClasses = {
    primary: 'text-primary',
    secondary: 'text-secondary-foreground',
    muted: 'text-muted-foreground',
}

export function LoadingSpinner({
    size = 'md',
    className,
    color = 'primary'
}: LoadingSpinnerProps) {
    return (
        <div
            className={cn('relative logo-loading', className)}
            role="status"
            aria-label="Loading"
        >
            <img
                src="/images/ICON_WHITE.svg"
                alt="Loading..."
                className={cn('relative z-10', sizeClasses[size])}
            />
            <span className="sr-only">Loading...</span>
        </div>
    )
}

// Alternative loading spinner with dots
export function LoadingDots({ className }: { className?: string }) {
    return (
        <div className={cn('flex space-x-1', className)}>
            <div className="h-2 w-2 bg-current rounded-full animate-pulse" />
            <div className="h-2 w-2 bg-current rounded-full animate-pulse" style={{ animationDelay: '0.1s' }} />
            <div className="h-2 w-2 bg-current rounded-full animate-pulse" style={{ animationDelay: '0.2s' }} />
        </div>
    )
}

// Loading skeleton component
interface LoadingSkeletonProps {
    className?: string
    lines?: number
}

export function LoadingSkeleton({ className, lines = 1 }: LoadingSkeletonProps) {
    return (
        <div className={cn('space-y-2', className)}>
            {Array.from({ length: lines }).map((_, i) => (
                <div
                    key={i}
                    className="h-4 bg-muted rounded animate-pulse"
                    style={{ width: `${Math.random() * 40 + 60}%` }}
                />
            ))}
        </div>
    )
}